import { IEventEnrollment } from '../../store/admin/eventEnrollments/store';

export const isEventEnrollment = (item: any): item is IEventEnrollment =>
  (item as IEventEnrollment).user !== undefined;
